import React, { useEffect } from "react";
import { AiFillHtml5 } from "react-icons/ai";
import {
  DiCss3,
  DiNodejs,
  DiReact,
  DiMysql,
  DiPhp,
  DiPython,
  DiJavascript1,
} from "react-icons/di";
import {
  SiCplusplus,
  SiNextdotjs,
  SiFigma,
  SiMongodb,
  SiTypescript,
} from "react-icons/si";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const skillsTag = [
  {
    name: "Casual",
    id: 1,
  },
  {
    name: "Dedicated",
    id: 2,
  },
  {
    name: "UnStoppable",
    id: 3,
  },
];

const casual = [
  {
    name: "mySql",
    icon: <DiMysql />,
  },
  {
    name: "PHP",
    icon: <DiPhp />,
  },
  {
    name: "C++",
    icon: <SiCplusplus />,
  },
  {
    name: "Figma",
    icon: <SiFigma />,
  },
];

const unstoppable = [
  {
    name: "HTML5",
    icon: <AiFillHtml5 />,
  },
  {
    name: "CSS3",
    icon: <DiCss3 />,
  },
  {
    name: "ReactJs",
    icon: <DiReact />,
  },
  {
    name: "JavaScript",
    icon: <DiJavascript1 />,
  },
];

const dedicated = [
  {
    name: "MongoDB",
    icon: <SiMongodb />,
  },
  {
    name: "TypeScript",
    icon: <SiTypescript />,
  },
  {
    name: "Python",
    icon: <DiPython />,
  },
  {
    name: "NodeJs",
    icon: <DiNodejs />,
  },
  {
    name: "NextJs",
    icon: <SiNextdotjs />,
  },
];
const SkillsList = () => {
  const { ref, inView } = useInView();
  const controls = useAnimation();
  const container = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        ease: "easeOut",
        delayChildren: 0.2,
        staggerChildren: 0.1,
      },
    },
  };

  const innerContainer = {
    hidden: {
      opacity: 0,
      translateX: -10,
    },
    show: {
      opacity: 1,
      translateX: 0,
      transition: {
        type: "spring",
      },
    },
  };

  useEffect(() => {
    if (inView) controls.start("show");
  }, [controls, inView]);

  return (
    <section className="skillsSetWrapper">
      <div className="skillsTag">
        {skillsTag.map((tags, id) => {
          return (
            <div className="tag" key={id}>
              {tags.name}
            </div>
          );
        })}
      </div>

      <motion.div
        className="skillsList"
        animate={controls}
        ref={ref}
        variants={container}
        initial="hidden"
      >
        <motion.div className="casual skillDiv">
          {casual.map((skill, id) => {
            return (
              <motion.div key={id} className="skill" variants={innerContainer}>
                {skill.icon}
              </motion.div>
            );
          })}
        </motion.div>
        <motion.div className="dedicated skillDiv" variants={innerContainer}>
          {dedicated.map((skill, id) => {
            return (
              <motion.div key={id} className="skill" variants={innerContainer}>
                {skill.icon}
              </motion.div>
            );
          })}
        </motion.div>
        <motion.div className="unstop skillDiv" variants={innerContainer}>
          {unstoppable.map((skill, id) => {
            return (
              <motion.div key={id} className="skill" variants={innerContainer}>
                {skill.icon}
              </motion.div>
            );
          })}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default SkillsList;
